<template lang="pug">
#Filters.mt4
    v-select(:items="categories" color="primary" dense label="Choose the type of service you need" v-model="selected" clearable)

</template>

<script>
import categoryNames from '@/categoryNames';
import { EventBus } from '@/EventBus';
export default {
    name: 'Filters',
    data: () => ({ selected: null }),
    created() {
        window.Filters = this;
    },
    computed: {
        categories() {
            return Object.entries({
                '-': 'Show all services',
                ...categoryNames,
            }).map(([k, v]) => ({
                text: v,
                value: k,
            }));
        },
    },
    watch: {
        selected() {
            console.log(this.selected);
            EventBus.$emit('filter-change', this.selected);
        },
    },
};
</script>

<style scoped></style>
